module.exports = __webpack_public_path__ + "static/media/fansLegendIcon.7a7cfc14.svg";